import React from 'react';
import { CTAButton } from './CTAButton';
import { Star, Shield, Zap } from 'lucide-react';
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/tNUwkuWAd2acQyqjdygdXd/ChatGPT-Image-2-jul-2026_-08_17_03-p.m..webp';
const CHECKOUT_URL = 'https://nutritionist-pro.impultienda.ar/checkout';
export function FinalCTA() {
  return <section className="py-10 px-4 bg-brand-petrol text-white border-t-8 border-brand-gold" data-id="element-47">
      <div className="max-w-3xl mx-auto text-center" data-id="element-48">
        <p className="text-sm font-extrabold text-brand-gold uppercase tracking-widest mb-2" data-id="element-49">
          ONE LAST CHANCE
        </p>

        <div className="text-base sm:text-lg font-medium mb-5 leading-snug max-w-2xl mx-auto space-y-2" data-id="element-50">
          <p data-id="element-51">
            Your clients deserve more than nutrition plans created at the last
            minute because you simply don't have enough time.
          </p>
          <p data-id="element-52">
            Stop spending hours creating assessment forms, educational
            resources, meal planning templates, and follow-up documents every
            single week. Stop wasting valuable time searching through dozens of
            folders looking for the right document.
          </p>
          <p data-id="element-53">
            Give every client a professional, organized, and premium
            consultation experience. Give yourself the complete professional
            nutrition system you wish you had from your very first client.
          </p>
        </div>

        <a href={CHECKOUT_URL} className="block cursor-pointer" data-id="element-54">
          <img src={PRODUCT_IMG} alt="Nutritionist Pro 6-in-1 System" className="w-full max-w-[220px] mx-auto object-contain drop-shadow-2xl mb-5 hover:scale-[1.03] transition-transform duration-300" data-id="element-55" />
        </a>

        <div className="bg-white/10 border-2 border-white/20 rounded-xl p-4 mb-5 shadow-lg" data-id="element-56">
          <p className="text-sm sm:text-base font-bold mb-1 uppercase tracking-wide" data-id="element-57">
            🥗 NUTRITIONIST PRO™ — Complete 6-in-1 System + 5 Premium Bonuses
          </p>
          <p className="text-lg mb-0.5" data-id="element-58">
            <span className="line-through opacity-70" data-id="element-59">Regular Price: $97</span>
          </p>
          <p className="text-4xl font-serif font-extrabold text-brand-gold" data-id="element-60">
            Today Only: $27 USD
          </p>
        </div>

        <CTAButton href={CHECKOUT_URL} className="max-w-md mx-auto !bg-brand-gold !text-brand-graphite border-none shadow-[0_4px_14px_0_rgba(200,168,107,0.39)] hover:shadow-[0_6px_20px_rgba(200,168,107,0.23)] hover:bg-brand-gold/90 mb-4" data-id="element-61">
          🚀 YES! I WANT MY NUTRITIONIST PRO™ SYSTEM
        </CTAButton>

        <div className="flex flex-wrap justify-center items-center gap-x-5 gap-y-2 text-xs sm:text-sm font-bold opacity-90" data-id="element-62">
          <div className="flex items-center gap-1" data-id="element-63">
            <Zap className="w-4 h-4 text-brand-gold" data-id="element-64" />
            <span data-id="element-65">Immediate Access • Delivered Instantly by Email</span>
          </div>
          <span className="hidden sm:inline text-brand-gold" data-id="element-66">•</span>
          <div className="flex items-center gap-1" data-id="element-67">
            <Star className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-68" />
            <span data-id="element-69">4.9/5 — Verified Professional Reviews</span>
          </div>
          <span className="hidden sm:inline text-brand-gold" data-id="element-70">•</span>
          <div className="flex items-center gap-1" data-id="element-71">
            <Shield className="w-4 h-4 text-brand-gold" data-id="element-72" />
            <span data-id="element-73">7-Day Money-Back Guarantee — Zero Risk</span>
          </div>
        </div>
      </div>
    </section>;
}